// extracted by mini-css-extract-plugin
export var imageSlice = "styles-module--image-slice--vbnJm";
export var primary = "#06004d";
export var secondary = "#4dafd7";